import { normalizePostflopRequestPosition } from './postflopPosition';

// These are the PLO5 50bb SRP positions with stored flop solutions.
export const isPostflopPositionAvailable = (isPlo5, table, stack, pot, position) => (
  !isPlo5 || table !== '6max' || stack !== '50bb'
  || (pot === 'SRP' && ['COvsBTN', 'BTNvsBB', 'SBvsBB'].includes(
    normalizePostflopRequestPosition(pot, position, table),
  ))
);

export default isPostflopPositionAvailable;
